import React from 'react';
import Container from "@mui/material/Container";
import CustomMarkdown from "../components/customMarkdown/CustomMarkdown";

function ReturnPolicy() {
    return (
        <Container maxWidth="md" sx={{p:6}}>
            <CustomMarkdown children={['legal.returnPolicy']}/>
        </Container>
    );
}

export default ReturnPolicy;
